import "./backdrop.scss";

interface IBackDrop {
    show: boolean;
    close: () => void;
    type: "Normal" | "Blur"
}

const BackDrop = ({show, close, type}: IBackDrop) => {
    return (
        show ? <div onClick={close} className={`BackDrop ${type}`}></div> : null
    );
}

export default BackDrop;